import React, { useMemo } from 'react';
import Composer from '../../../../components/Composer';
import RunProgress from '../RunProgress';
import Thread from './components/Thread';
import useThreadScroll from '../../../../hooks/useThreadScroll';
import './styles.scss';

// The scroll container: the thread, the run's progress and the composer. Each is
// memoized on what it reads (Thread, RunProgress, Composer), so a keystroke, a poll
// or an edit in the script panel renders only the part it concerns.
export default function Conversation({ studio: s, visible, onOpenScript, onTeleprompter }) {
  const { t, current, run } = s;
  const messages = useMemo(() => s.snapshot.messages.filter(m => m.project_id === current.id), [s.snapshot.messages, current.id]);
  const { scrollerRef } = useThreadScroll(messages.length, current.id);
  return <section ref={scrollerRef} className={`studio-conversation ${visible ? 'is-visible' : ''}`} aria-label={t('chat')}>
    <div className="studio-messages" role="log" aria-live="polite" aria-relevant="additions">
      <Thread studio={s} messages={messages} onOpenScript={onOpenScript} onTeleprompter={onTeleprompter} />
      {run && <RunProgress studio={s} />}
    </div>
    <Composer studio={s} compact />
  </section>;
}
